import { Component } from 'react';
import { connect } from 'react-redux';
import api from 'api';
import { actions } from 'store';
import { ConfirmButton } from 'components/common';

const CertificatesSetDefault = connect((state) => state)(
  class extends Component {
    delete = async () => {
      const { dispatch, templateId } = this.props;
      await api.put(`/admin/server-config`, {
        data: { defaultCertificateTemplateId: templateId || null }
      });
      const response = await api.get('/admin/server-config');
      dispatch(actions.setServerConfig(response.data.data));
      return true;
    };

    render() {
      const {
        messages,
        serverConfig: { defaultCertificateTemplateId },
        templateId
      } = this.props;

      return (
        <ConfirmButton
          actionText={messages.siteCertificatesSetDefault}
          buttonIcon="check-circle"
          buttonText={messages.siteCertificatesSetDefault}
          confirmText={messages.siteCertificatesSetDefaultConfirm}
          confirmTitle={messages.siteCertificatesSetDefault}
          disabled={defaultCertificateTemplateId === templateId}
          onConfirm={this.delete}
          successMessage={messages.siteCertificatesSetDefaultSuccess}
          stopPropagation={true}
        />
      );
    }
  }
);

export default CertificatesSetDefault;
